// Bouwt de Dif3r3nt-nieuwsbrief voor de Store als e-mail-HTML (tabellen en inline stijlen, zodat Gmail en Outlook
// hem goed tonen). Alle gegevens komen uit de Store: producten, prijzen, foto's en categorieën uit de database,
// links naar de echte pagina's van de winkel. Elk onderdeel (logo, balk, knoppen, foto's, titels, categorieën,
// voettekst) is een link.

export const STORE_URL = "https://store.dif3r3nt.nl";
export const STORE_MAIL = "store@dif3r3nt.nl";
export const GRATIS_VERZENDEN_VANAF = 50; // zelfde grens als GRATIS_VERZENDEN_VANAF_CENT in de Store

const K = {
  achtergrond: "#0b0b14", kaart: "#12121f", tegel: "#1b1b2e", beeld: "#24243b",
  tekst: "#ffffff", zacht: "#c8c6e0", dim: "#a9a6c9", stil: "#7c7a9c", lijn: "#44446a",
  paars: "#8a4dff", blauw: "#3b8bff", licht: "#c9a8ff", accent: "#8f7bff",
};
const VERLOOP = `background:${K.paars};background-image:linear-gradient(90deg,${K.paars},${K.blauw});`;

export const esc = (t) => String(t == null ? "" : t).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");

export const productUrl = (p) => `${STORE_URL}/winkel/${p.id}`;
export const categorieUrl = (c) => `${STORE_URL}/winkel?categorie=${encodeURIComponent(c.key)}`;

// Zelfde regel als effectievePrijsCent in de Store: een verlopen korting telt niet mee.
export function prijsVan(p, nu = Date.now()) {
  const basis = Number(p.sellPrice) || 0;
  const pct = Number(p.kortingPct) || 0;
  const verlopen = p.kortingTot && new Date(p.kortingTot).getTime() < nu;
  if (pct <= 0 || verlopen) return { prijs: basis, was: null, pct: 0 };
  return { prijs: Math.max(0, Math.round(basis * (100 - pct)) / 100), was: basis, pct };
}
export const eurTekst = (n) => "€" + Number(n || 0).toFixed(2).replace(".", ",");

// De Store toont de titel kort; een leverancierstitel kan erg lang zijn.
export const kortTitel = (t, max = 60) => {
  const s = String(t || "").replace(/\s+/g, " ").trim();
  return s.length <= max ? s : s.slice(0, max - 1).replace(/\s+\S*$/, "") + "…";
};

const FONT = "font-family:Arial,Helvetica,sans-serif;";

function tegel(p, rechts) {
  const { prijs, was, pct } = prijsVan(p);
  const url = productUrl(p);
  const wasHtml = was ? ` <span style="color:${K.stil};text-decoration:line-through;font-weight:normal;">${eurTekst(was)}</span>` : "";
  const badge = pct ? `<div style="${FONT}font-size:11px;font-weight:bold;letter-spacing:1px;color:${K.licht};padding-bottom:6px;">-${pct}%</div>` : "";
  const foto = p.foto
    ? `<a href="${url}" style="text-decoration:none;"><img src="${esc(p.foto)}" width="255" alt="${esc(kortTitel(p.title))}" style="display:block;width:100%;height:auto;border:0;border-radius:12px 12px 0 0;background:${K.beeld};"></a>`
    : `<a href="${url}" style="text-decoration:none;display:block;height:200px;background:${K.beeld};border-radius:12px 12px 0 0;">&nbsp;</a>`;
  return `<td class="col${rechts ? "" : " col-gap"}" width="50%" valign="top" style="padding-${rechts ? "left" : "right"}:8px;">
          <table role="presentation" width="100%" cellpadding="0" cellspacing="0" border="0" style="background:${K.tegel};border-radius:12px;">
            <tr><td align="center" style="padding:0;">${foto}</td></tr>
            <tr><td align="center" style="padding:16px 12px 18px 12px;">
              ${badge}
              <div style="${FONT}font-size:14px;line-height:19px;font-weight:bold;padding-bottom:6px;"><a href="${url}" style="color:${K.tekst};text-decoration:none;">${esc(kortTitel(p.title))}</a></div>
              <div style="${FONT}font-size:15px;font-weight:bold;color:${K.licht};padding-bottom:12px;">${eurTekst(prijs)}${wasHtml}</div>
              <a href="${url}" style="${FONT}font-size:12px;letter-spacing:2px;font-weight:bold;color:${K.licht};text-decoration:none;border-bottom:2px solid ${K.paars};padding-bottom:2px;">SHOP NU</a>
            </td></tr>
          </table>
        </td>`;
}

function tegelRij(paar) {
  const [a, b] = paar;
  return `<tr><td class="pad" style="padding:0 30px 16px 30px;">
      <table role="presentation" width="100%" cellpadding="0" cellspacing="0" border="0"><tr>
        ${tegel(a, false)}
        ${b ? tegel(b, true) : `<td class="col" width="50%">&nbsp;</td>`}
      </tr></table>
    </td></tr>`;
}

/**
 * @param {object} o
 * @param {string} o.label     bovenregel boven de kop
 * @param {string} o.kop       kop (een regeleinde in de kop wordt een nieuwe regel)
 * @param {string} o.intro     inleidende tekst
 * @param {string} o.knop      tekst van de hoofdknop
 * @param {Array}  o.producten producten uit de Store: id, title, sellPrice, kortingPct, kortingTot, foto
 * @param {Array}  o.categorieen actieve categorieën uit de Store: key, label
 * @param {string} o.afmeldUrl link om uit te schrijven ("{{AFMELD_URL}}" voor het echte verzenden)
 * @param {string} o.email     adres van de ontvanger ("{{EMAIL}}" voor het echte verzenden)
 * @param {string} o.logoUrl   openbare link naar het D3-logo
 */
export function bouwNieuwsbrief(o) {
  const producten = (o.producten || []).slice(0, 6);
  const paren = [];
  for (let i = 0; i < producten.length; i += 2) paren.push(producten.slice(i, i + 2));
  const kopRegels = String(o.kop || "").split("\n").map((r) => r.trim()).filter(Boolean);
  const kopHtml = kopRegels.map((r, i) => (i === kopRegels.length - 1 && kopRegels.length > 1 ? `<span style="color:#a98bff;">${esc(r)}</span>` : esc(r))).join("<br>");
  const cats = (o.categorieen || []).slice(0, 6);
  const catHtml = cats.map((c) => `<a href="${categorieUrl(c)}" style="color:${K.tekst};text-decoration:none;">${esc(String(c.label).toUpperCase())} &rsaquo;</a>`)
    .join(`&nbsp;&nbsp;<span style="color:${K.lijn};">|</span>&nbsp;&nbsp; `);
  const gratis = `GRATIS VERZENDING BOVEN €${GRATIS_VERZENDEN_VANAF}`;
  const sep = `&nbsp;<span style="color:${K.lijn};">|</span>&nbsp;`;

  return `<!DOCTYPE html>
<html lang="nl">
<head>
<meta charset="utf-8">
<meta name="viewport" content="width=device-width, initial-scale=1">
<meta name="color-scheme" content="dark">
<title>${esc((kopRegels.join(" ") || "Nieuwsbrief") + " | Dif3r3nt Store")}</title>
<style>
  @media only screen and (max-width:620px){
    .wrap{width:100%!important}
    .pad{padding-left:20px!important;padding-right:20px!important}
    .h1{font-size:30px!important;line-height:34px!important}
    .col{display:block!important;width:100%!important}
    .col-gap{padding:0 0 16px 0!important}
  }
</style>
</head>
<body style="margin:0;padding:0;background:${K.achtergrond};">
<div style="display:none;max-height:0;overflow:hidden;opacity:0;color:${K.achtergrond};">${esc(o.intro || "")} ${gratis.toLowerCase()}.</div>
<table role="presentation" width="100%" cellpadding="0" cellspacing="0" border="0" style="background:${K.achtergrond};">
<tr><td align="center" style="padding:0;">

  <table role="presentation" class="wrap" width="600" cellpadding="0" cellspacing="0" border="0" style="width:600px;max-width:600px;">
    <tr><td class="pad" align="center" style="padding:14px 30px;${FONT}font-size:12px;letter-spacing:1px;">
      <a href="${STORE_URL}/winkel" style="color:${K.dim};text-decoration:none;">${gratis}</a>${sep}<a href="${STORE_URL}/winkel" style="color:${K.licht};text-decoration:none;font-weight:bold;">SHOP NU</a>
    </td></tr>
  </table>

  <table role="presentation" class="wrap" width="600" cellpadding="0" cellspacing="0" border="0" style="width:600px;max-width:600px;background:${K.kaart};border-radius:16px;">

    <tr><td align="center" style="padding:36px 30px 8px 30px;">
      <a href="${STORE_URL}" style="text-decoration:none;"><img src="${esc(o.logoUrl)}" width="72" height="72" alt="Dif3r3nt" style="display:block;border:0;width:72px;height:72px;"></a>
      <div style="${FONT}font-size:13px;letter-spacing:6px;font-weight:bold;padding-top:10px;"><a href="${STORE_URL}" style="color:${K.tekst};text-decoration:none;">DIF3R3NT</a></div>
    </td></tr>

    <tr><td class="pad" align="center" style="padding:28px 40px 8px 40px;">
      <div style="${FONT}font-size:12px;letter-spacing:4px;color:${K.accent};font-weight:bold;">${esc(String(o.label || "").toUpperCase())}</div>
      <div class="h1" style="font-family:'Arial Black',Arial,Helvetica,sans-serif;font-size:40px;line-height:44px;font-weight:900;color:${K.tekst};padding-top:14px;">${kopHtml}</div>
      <div style="height:4px;width:80px;margin:20px auto 0 auto;${VERLOOP}border-radius:2px;line-height:4px;font-size:0;">&nbsp;</div>
      <p style="${FONT}font-size:16px;line-height:25px;color:${K.zacht};margin:22px 0 0 0;">${esc(o.intro || "")}</p>
    </td></tr>

    <tr><td align="center" style="padding:28px 40px 24px 40px;">
      <table role="presentation" cellpadding="0" cellspacing="0" border="0"><tr>
        <td align="center" bgcolor="${K.paars}" style="border-radius:999px;${VERLOOP}">
          <a href="${STORE_URL}/winkel" style="display:inline-block;padding:16px 36px;${FONT}font-size:14px;letter-spacing:2px;font-weight:bold;color:#ffffff;text-decoration:none;">${esc(String(o.knop || "ONTDEK DE COLLECTIE").toUpperCase())}</a>
        </td>
      </tr></table>
    </td></tr>

    ${paren.map(tegelRij).join("\n    ")}

    ${cats.length ? `<tr><td align="center" style="padding:10px 30px 32px 30px;${FONT}font-size:13px;line-height:26px;letter-spacing:2px;font-weight:bold;">${catHtml}</td></tr>` : `<tr><td style="padding:0 0 16px 0;">&nbsp;</td></tr>`}
  </table>

  <table role="presentation" class="wrap" width="600" cellpadding="0" cellspacing="0" border="0" style="width:600px;max-width:600px;">
    <tr><td class="pad" align="center" style="padding:26px 30px 6px 30px;${FONT}font-size:12px;letter-spacing:2px;font-weight:bold;">
      <a href="${STORE_URL}/winkel" style="color:${K.licht};text-decoration:none;">DE WINKEL</a>${sep}<a href="${STORE_URL}/retourneren" style="color:${K.licht};text-decoration:none;">BEZORGEN &amp; RETOUR</a>${sep}<a href="mailto:${STORE_MAIL}" style="color:${K.licht};text-decoration:none;">HULP</a>
    </td></tr>
    <tr><td class="pad" align="center" style="padding:14px 30px 40px 30px;${FONT}font-size:12px;line-height:19px;color:${K.stil};">
      Deze e-mail is verzonden naar ${esc(o.email)}. Voeg <a href="mailto:${STORE_MAIL}" style="color:${K.dim};text-decoration:underline;">${STORE_MAIL}</a> toe aan je adresboek om te verzekeren dat onze e-mails je postvak bereiken.<br><br>
      <a href="${esc(o.afmeldUrl)}" style="color:${K.dim};text-decoration:underline;">Klik hier om je e-mailvoorkeuren aan te passen of uit te schrijven.</a><br><br>
      <a href="${STORE_URL}/voorwaarden" style="color:${K.stil};text-decoration:underline;">Voorwaarden</a> &nbsp;·&nbsp; <a href="${STORE_URL}/privacy" style="color:${K.stil};text-decoration:underline;">Privacy</a> &nbsp;·&nbsp; <a href="${STORE_URL}" style="color:${K.stil};text-decoration:none;">&copy; Dif3r3nt Store</a>
    </td></tr>
  </table>

</td></tr>
</table>
</body>
</html>
`;
}

// Elke href in de nieuwsbrief moet een echte link zijn (geen lege of nog niet ingevulde plaatshouder
// behalve de twee bewuste: {{AFMELD_URL}} en {{EMAIL}} bij het echte verzenden).
export function ongeldigeLinks(html) {
  const fout = [];
  const re = /href="([^"]*)"/g;
  let m;
  while ((m = re.exec(html))) {
    const h = m[1];
    if (!/^(https:\/\/|mailto:)/.test(h) && h !== "{{AFMELD_URL}}") fout.push(h);
  }
  return fout;
}
